import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { defaultBranch } from 'src/constants/branches';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { ICheckoutDependencies } from 'src/mobx/checkoutStore/types';
import { modalStore } from 'src/mobx/modalStore';
import { IBranch } from 'src/types/branches';
import './style.scss';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import AddButton from '~/view/components/Controls/AddButton/AddButton';
import { ORDER_EDIT_STAGE } from '~/mobx/checkoutStore/constants';
import CopyButton from '~/view/components/Controls/CopyButton/CopyButton';
import { useCheckoutStoreContext } from '../../../context';

const CheckoutAddressesDraft: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const onSelectAddress = async (option: IPickerOption[]) => {
    if (!option[0]) {
      return;
    }
    checkoutStore.selectAddress(option[0]);
  };

  const changeDeliveryData = useCallback((branch: IBranch | undefined, location: ICheckoutDependencies['location'], delivery_type: DELIVERY_TYPE) => {
    checkoutStore.selectBranch(branch || defaultBranch);
    checkoutStore.selectLocation(location);
    if (delivery_type) checkoutStore.changeDeliveryType(delivery_type);
    if (location) {
      checkoutStore.selectedAddress = {
        label: location.address,
        value: location.address_id,
      };
      checkoutStore.selectedZone = undefined;
    }
  }, []);

  const openDeliveryPicker = useCallback(() => {
    modalStore.openDeliveryType({
      editable: checkoutStore.isDraft,
      location: checkoutStore.dependencies.location,
      customer: checkoutStore.dependencies.customer?.id,
      branch: checkoutStore.dependencies.branch,
      delivery_type: checkoutStore.params.delivery_type === 'd' ? DELIVERY_TYPE.DELIVERY : DELIVERY_TYPE.PICKUP,
      onChange: changeDeliveryData,
    });
  }, [
    checkoutStore.isDraft,
    checkoutStore.dependencies.location,
    checkoutStore.dependencies.customer,
    checkoutStore.dependencies.branch,
    checkoutStore.params.delivery_type,
    changeDeliveryData,
  ]);

  return checkoutStore.addresses.length || checkoutStore.selectedAddress ? (
    <>
      <Picker
        className="flex-grow-1"
        inputClassName="checkout-addresses"
        placeholder="select_address"
        selectedOptions={checkoutStore.selectedAddress ? [checkoutStore.selectedAddress] : []}
        options={checkoutStore.addresses}
        onSelect={onSelectAddress}
        numberVisibleOptionsInDropdown={8}
        hideResetIcon
        disableUnavailable
      />
      <AddButton iconSize={16} iconClassName="add-button-checkout" className="ml-2" onAdd={openDeliveryPicker} />
      {checkoutStore.orderEditStage === ORDER_EDIT_STAGE.CHECKOUT && checkoutStore.selectedAddress && (
        <CopyButton className="copy-button-checkout" data={checkoutStore.dependencies.location?.address} tooltipMessage="copied_to_clickboard" />
      )}
    </>
  ) : (
    <AddButton iconSize={16} iconClassName="add-button-checkout_empty" onAdd={openDeliveryPicker} />
  );
});

export default CheckoutAddressesDraft;
